export const whatsappMarketingFaqs = [
    {
        title: 'What is WhatsApp Broadcast, and how does it work?',
        description: 'WhatsApp Broadcast lets you send bulk messages to multiple leads at once. After activating a plan, you can select a message templates or create your own message, upload buyer data or choose buyers directly from your ReadPro dashboard, and then either schedule the message or send it instantly. It’s a fast and efficient way to reach multiple buyers in just a few steps.',
    },
    {
        title: 'How are messages sent?',
        description: 'Your messages are delivered through an official WhatsApp Business API, ensuring high deliverability, security, and compliance.',
    },
    {
        title: 'Is this GDPR-compliant and safe?',
        description: 'Yes, it is fully GDPR-compliant and completely safe. Your data is 100% secure, and no one — not even Magicbricks — can access, store, or share your user data.',
    },
    {
        title: 'Can I track delivery and response rates?',
        description: 'Absolutely! Every plan includes detailed delivery reports and campaign analytics to help you optimize your outreach.',
    },
    {
        title: 'What kind of messages can I send?',
        description: ' You can send property listings, updates, offers, and even automated replies using templates or write your own —making communication fast and effective.',
    },
    {
        title: 'Can I choose my audience?',
        description: ' Yes! You can send messages to your verified leads or select specific buyer segments for highly targeted campaigns.',
    },
]